/* Pestocart cart drawer | assets/pestocart-cart.js
   Reshapes Dawn's cart drawer: header count, trust strip, empty state,
   coupon field, recommendations rail, savings bar, payment marks.
   No theme template is edited, so Dawn updates stay safe. */
(function () {
  "use strict";

  var CFG = {
    strip: "Trusted by families across India",
    emptyTitle: "Oops! Your cart is empty!",
    emptySub: "There is nothing in your cart. Let's add some items.",
    emptyCta: "Shop Now",
    bagLabel: "Shopping Bag",
    checkout: "Buy Now",
    recsTitle: "You may also like",
    recsLimit: 6,
    couponPlaceholder: "Enter coupon code",

    /* Prepaid badge shown above the checkout button. Set to 0 to hide. */
    prepaidPct: 5,

    /* Payment icons on the Buy Now button.
       Upload the official badges in Shopify admin under Content > Files,
       copy each link, and paste them in here. Leave the array empty and no
       icons render, which is better than drawing imitations of the logos. */
    payIcons: []
  };

  /* Drawer width. One number, written to --pcc-w so the stylesheet and the
     inline styles can never disagree. */
  var DESKTOP_W = 430;
  var MOBILE_AT = 750;

  var ART =
    '<svg class="pcc-empty-art" viewBox="0 0 120 104" width="140" height="121" fill="none" aria-hidden="true">' +
    '<path d="M4 8h18l14 58h58" stroke="currentColor" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M30 22h84l-10 34H38" stroke="currentColor" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<circle cx="44" cy="90" r="9" stroke="currentColor" stroke-width="6"/>' +
    '<circle cx="88" cy="90" r="9" stroke="currentColor" stroke-width="6"/>' +
    '<circle cx="60" cy="36" r="2.6" fill="currentColor"/><circle cx="82" cy="36" r="2.6" fill="currentColor"/>' +
    '<path d="M62 48c4-4 12-4 16 0" stroke="currentColor" stroke-width="4" stroke-linecap="round"/></svg>';

  function payMarks() {
    if (!CFG.payIcons || !CFG.payIcons.length) return "";
    return (
      '<span class="pcc-pays">' +
      CFG.payIcons
        .map(function (u) {
          return '<span><img src="' + u + '" alt="" height="16" loading="lazy"></span>';
        })
        .join("") +
      "</span>"
    );
  }

  var cartUrl = function (p) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    return root.replace(/\/$/, "") + p;
  };

  function money(cents) {
    return (
      "₹" +
      (cents / 100).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    );
  }

  function getCart() {
    return fetch(cartUrl("/cart.js"), { headers: { Accept: "application/json" } }).then(function (r) {
      return r.ok ? r.json() : null;
    });
  }

  function panelOf(drawer) {
    return drawer.querySelector(".drawer__inner") || drawer.querySelector(".cart-drawer__inner");
  }

  /* Dawn renders a header only when the cart has items. When it is empty there
     is no .drawer__header at all, which is why the bar and strip vanished.
     Build one so both states look the same. */
  function ensureHeader(drawer) {
    var panel = panelOf(drawer);
    if (!panel || panel.querySelector(".drawer__header")) return;

    var header = document.createElement("div");
    header.className = "drawer__header";
    header.innerHTML = '<h2 class="drawer__heading"></h2>';

    /* reuse Dawn's own close button so its click handler keeps working */
    var close = drawer.querySelector(".drawer__close");
    if (close) header.appendChild(close);

    panel.insertAdjacentElement("afterbegin", header);
  }

  /* In the empty state Dawn prints the header AFTER the empty content, which is
     why the trust strip kept landing at the bottom. Lift both to the top and
     keep the strip immediately under the header. */
  function liftHeader(drawer) {
    var panel = panelOf(drawer);
    if (!panel) return;
    var header = panel.querySelector(".drawer__header");
    if (!header) return;
    if (panel.firstElementChild !== header) panel.insertAdjacentElement("afterbegin", header);
    var strip = panel.querySelector(".pcc-strip");
    if (strip && header.nextElementSibling !== strip) header.insertAdjacentElement("afterend", strip);
  }

  /* ---------- static reshaping ---------- */
  function decorate(drawer) {
    ensureHeader(drawer);
    liftHeader(drawer);

    var heading = drawer.querySelector(".drawer__heading");
    if (heading && !heading.dataset.pcc) {
      heading.dataset.pcc = "1";
      heading.innerHTML = '<i class="pcc-back"></i><span class="pcc-bag">' + CFG.bagLabel + "</span>";
    }

    var header = drawer.querySelector(".drawer__header");
    if (header && !drawer.querySelector(".pcc-strip")) {
      var strip = document.createElement("div");
      strip.className = "pcc-strip";
      strip.textContent = CFG.strip;
      strip.setAttribute("style",
        "display:block;width:100%;margin:0;flex:0 0 auto;background:#1B4332;color:#fff;" +
        "font-size:12.5px;font-weight:600;padding:9px 16px;text-align:center;box-sizing:border-box");
      header.insertAdjacentElement("afterend", strip);
    }
    liftHeader(drawer);

    var empty = drawer.querySelector(".cart-drawer__empty-content");
    if (empty && !empty.dataset.pcc) {
      empty.dataset.pcc = "1";
      var title = empty.querySelector(".cart__empty-text");
      if (title) {
        title.textContent = CFG.emptyTitle;
        title.insertAdjacentHTML("beforebegin", ART);
        var sub = document.createElement("p");
        sub.className = "pcc-empty-sub";
        sub.textContent = CFG.emptySub;
        title.insertAdjacentElement("afterend", sub);
      }
      var cta = empty.querySelector("a.button, .button");
      if (cta) cta.textContent = CFG.emptyCta;
    }

    var checkout = drawer.querySelector('.cart__ctas button[name="checkout"], #CartDrawer-Checkout');
    if (checkout && !checkout.dataset.pcc) {
      checkout.dataset.pcc = "1";
      checkout.innerHTML = "<span>" + CFG.checkout + "</span>" + payMarks();
    }
  }

  /* ---------- coupon ---------- */
  function coupon(drawer, contents) {
    if (drawer.querySelector(".pcc-coupon")) return;

    var wrap = document.createElement("div");
    wrap.className = "pcc-coupon";
    wrap.innerHTML =
      '<div class="pcc-coupon-row">' +
      '<input type="text" autocomplete="off" spellcheck="false" aria-label="Coupon code" placeholder="' +
      CFG.couponPlaceholder +
      '">' +
      "<button type=\"button\" disabled>Apply</button></div>" +
      '<div class="pcc-coupon-msg" hidden></div>';
    contents.appendChild(wrap);

    var input = wrap.querySelector("input");
    var btn = wrap.querySelector("button");
    var msg = wrap.querySelector(".pcc-coupon-msg");

    input.addEventListener("input", function () {
      btn.disabled = !input.value.trim();
    });
    input.addEventListener("keydown", function (e) {
      if (e.key === "Enter") {
        e.preventDefault();
        if (!btn.disabled) btn.click();
      }
    });

    btn.addEventListener("click", function () {
      var code = input.value.trim().toUpperCase();
      if (!code) return;
      btn.disabled = true;
      btn.textContent = "...";
      msg.hidden = true;

      /* Shopify has no theme API for applying a code to the cart. Hitting the
         /discount/ route sets the discount cookie, which carries into checkout.
         We then re-read the cart to see whether it actually took. */
      fetch(cartUrl("/discount/" + encodeURIComponent(code)), { redirect: "follow" })
        .then(getCart)
        .then(function (cart) {
          btn.textContent = "Apply";
          btn.disabled = false;
          msg.hidden = false;
          var applied =
            cart &&
            ((cart.total_discount && cart.total_discount > 0) ||
              (cart.discount_codes || []).some(function (d) {
                return d.applicable && String(d.code).toUpperCase() === code;
              }));
          if (applied) {
            msg.className = "pcc-coupon-msg ok";
            msg.textContent = "Code " + code + " applied.";
            refresh(drawer);
          } else {
            msg.className = "pcc-coupon-msg no";
            msg.textContent = "Code " + code + " is not valid for this cart.";
          }
        })
        .catch(function () {
          btn.textContent = "Apply";
          btn.disabled = false;
          msg.hidden = false;
          msg.className = "pcc-coupon-msg no";
          msg.textContent = "Could not check that code. It may still work at checkout.";
        });
    });
  }

  /* ---------- recommendations ---------- */
  function recs(drawer, contents, productId) {
    if (!productId || drawer.querySelector(".pcc-recs")) return;

    fetch(cartUrl("/recommendations/products.json?product_id=" + productId + "&limit=" + CFG.recsLimit), {
      headers: { Accept: "application/json" }
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (data) {
        var list = (data && data.products) || [];
        if (!list.length || drawer.querySelector(".pcc-recs")) return;

        var box = document.createElement("div");
        box.className = "pcc-recs";
        var rail = '<div class="pcc-recs-rail">';
        list.forEach(function (p) {
          var img = p.featured_image || (p.images && p.images[0]) || "";
          var off =
            p.compare_at_price && p.compare_at_price > p.price
              ? Math.round((1 - p.price / p.compare_at_price) * 100)
              : 0;
          rail +=
            '<a class="pcc-rec" href="' +
            p.url +
            '">' +
            (img ? '<img src="' + img + '" alt="" loading="lazy" width="56" height="56">' : "<span></span>") +
            '<span><span class="pcc-rec-t">' +
            p.title +
            '</span><span class="pcc-rec-p">' +
            (off ? "<s>" + money(p.compare_at_price) + "</s>" : "") +
            money(p.price) +
            "</span>" +
            (off ? '<span class="pcc-rec-off">' + off + "% off</span>" : "") +
            "</span></a>";
        });
        rail += "</div>";
        box.innerHTML =
          '<div class="pcc-recs-head">' +
          "<h3>" + CFG.recsTitle + "</h3>" +
          '<span class="pcc-recs-nav">' +
          '<button type="button" class="pcc-arw" data-dir="-1" aria-label="Scroll left">\u2039</button>' +
          '<button type="button" class="pcc-arw" data-dir="1" aria-label="Scroll right">\u203A</button>' +
          "</span></div>" + rail;
        contents.appendChild(box);

        var railEl = box.querySelector(".pcc-recs-rail");
        box.querySelectorAll(".pcc-arw").forEach(function (b) {
          b.addEventListener("click", function () {
            railEl.scrollBy({ left: 216 * +b.dataset.dir, behavior: "smooth" });
          });
        });
        sizeRail(drawer);
      })
      .catch(function () {
        /* recommendations are a nicety; the drawer works without them */
      });
  }

  /* ---------- live bits: count, savings, coupon, recs ---------- */
  function refresh(drawer) {
    var footer = drawer.querySelector(".drawer__footer");
    var contents = drawer.querySelector(".drawer__contents");

    getCart()
      .then(function (cart) {
        if (!cart) return;

        var bag = drawer.querySelector(".pcc-bag");
        if (bag) bag.textContent = CFG.bagLabel + " (" + cart.item_count + ")";

        if (!cart.item_count) return;

        if (contents) {
          coupon(drawer, contents);
          recs(drawer, contents, cart.items[0] && cart.items[0].product_id);
        }

        if (!footer) return;
        var gross = 0;
        cart.items.forEach(function (i) {
          var was = i.original_price || i.price;
          if (i.compare_at_price && i.compare_at_price > was) was = i.compare_at_price;
          gross += was * i.quantity;
        });
        var saved = gross - cart.total_price;

        /* prepaid badge above the checkout button */
        var ctas = footer.querySelector(".cart__ctas");
        if (ctas && CFG.prepaidPct > 0) {
          var pre = footer.querySelector(".pcc-prepaid");
          if (!pre) {
            pre = document.createElement("div");
            pre.className = "pcc-prepaid";
            ctas.insertAdjacentElement("beforebegin", pre);
          }
          pre.textContent =
            CFG.prepaidPct +
            "% off on prepaid \u00B7 save " +
            money(Math.round((cart.total_price * CFG.prepaidPct) / 100)) +
            " more";
        }

        var bar = footer.querySelector(".pcc-save");
        if (saved > 0) {
          if (!bar) {
            bar = document.createElement("div");
            bar.className = "pcc-save";
            footer.insertAdjacentElement("afterbegin", bar);
          }
          bar.textContent = "🎉 You're saving " + money(saved) + "!";
        } else if (bar) {
          bar.remove();
        }
      })
      .catch(function () {});
  }

  /* The rail must have a real width or overflow-x has nothing to scroll.
     Percentages inherit through Dawn's flex chain and collapse to content
     width, so take it from the panel, whose width we set ourselves. */
  function sizeRail(drawer) {
    var panel = panelOf(drawer);
    var box = drawer.querySelector(".pcc-recs");
    var rail = drawer.querySelector(".pcc-recs-rail");
    if (!panel || !box || !rail) return;
    var w = panel.clientWidth;
    if (!w) return;
    box.style.width = w + "px";
    box.style.maxWidth = w + "px";
    rail.style.width = w - 16 + "px";
    rail.style.maxWidth = w - 16 + "px";
    rail.style.overflowX = "auto";
  }

  function sizeDrawer(drawer) {
    /* .cart-drawer and .drawer__inner are flex items. With no line items they
       shrink to the width of their content, which is why the empty drawer came
       out narrower than the full one. width alone does not stop that, so set
       min-width as well, at every level. */
    var mobile = window.innerWidth < MOBILE_AT;
    var w = mobile ? "100vw" : DESKTOP_W + "px";

    document.documentElement.style.setProperty("--pcc-w", w);

    [drawer.querySelector("#CartDrawer"), drawer.querySelector(".cart-drawer"), panelOf(drawer)].forEach(
      function (el) {
        if (!el) return;
        el.style.setProperty("width", w, "important");
        el.style.setProperty("min-width", w, "important");
        el.style.setProperty("max-width", w, "important");
        el.style.setProperty("flex", "0 0 auto", "important");
        el.style.setProperty("margin-left", "auto", "important");
        el.style.setProperty("box-sizing", "border-box", "important");
      }
    );

    /* wrappers inside the panel stretch to it and fill the height, so the
       empty state is centred over the whole drawer instead of a short box */
    [
      ".drawer__inner-empty",
      ".cart-drawer__warnings",
      ".cart-drawer__form",
      "cart-drawer-items",
      ".drawer__contents"
    ].forEach(function (sel) {
      var el = drawer.querySelector(sel);
      if (!el) return;
      el.style.setProperty("width", "100%", "important");
      el.style.setProperty("max-width", "100%", "important");
      el.style.setProperty("min-width", "0", "important");
    });
  }

  function apply(drawer) {
    sizeDrawer(drawer);
    decorate(drawer);
    refresh(drawer);
    sizeRail(drawer);
  }

  function boot() {
    var drawer = document.querySelector("cart-drawer");
    if (!drawer) return;
    apply(drawer);

    /* Dawn re-renders the drawer through the Section Rendering API on every
       cart change, which wipes our additions. It also toggles .is-empty on the
       element itself, which is a class change, not a child change, so watch
       both. */
    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(function () {
        apply(drawer);
      }, 70);
    }).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ["class"] });

    window.addEventListener("resize", function () {
      sizeDrawer(drawer);
      sizeRail(drawer);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();